module.exports = _.clamp;